var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';
import React from 'react';
import styles from './MaskedTextField.module.css';
import { ReadOnlyField } from './ReadOnlyField';
export var AutoCompleteTypes;
(function (AutoCompleteTypes) {
    AutoCompleteTypes["TextBox"] = "TextBox";
    AutoCompleteTypes["UserInfo"] = "UserInfo";
})(AutoCompleteTypes || (AutoCompleteTypes = {}));
export var AlignType;
(function (AlignType) {
    AlignType["Left"] = "left";
    AlignType["Right"] = "right";
})(AlignType || (AlignType = {}));
var MaskedTextField = /** @class */ (function (_super) {
    __extends(MaskedTextField, _super);
    function MaskedTextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            cleaveInstance: null
        };
        _this.inputComponent = _this.props.formatOptions
            ? function (inputProps) {
                var inputRef = inputProps.inputRef, other = __rest(inputProps, ["inputRef"]);
                return (React.createElement(Cleave, __assign({}, other, { onInit: _this.initCleaveInstance, htmlRef: inputRef, options: _this.props.formatOptions, onChange: function (event) {
                        if (_this.props.onChange)
                            _this.props.onChange(event.target.value, event);
                    } })));
            }
            : _this.props.inputComponent
                ? _this.props.inputComponent
                : undefined;
        _this.onChange = function (e) {
            if (_this.props.readOnly)
                return;
            var cleanValue = _this.props.unformatFunction ? _this.props.unformatFunction(e.target.value) : e.target.value;
            var filteredValue = _this.props.filterFunction ? _this.props.filterFunction(cleanValue) : cleanValue;
            if (_this.props.onChange)
                _this.props.onChange(filteredValue, e);
        };
        _this.onClear = function (e) {
            if (_this.props.readOnly)
                return;
            setTimeout(function () {
                if (_this.inputElement && _this.inputElement.focus)
                    _this.inputElement.focus();
            }, 0);
            if (_this.state.cleaveInstance)
                _this.state.cleaveInstance.setRawValue('');
            if (_this.props.onClear)
                _this.props.onClear(e);
        };
        _this.bindElement = function (element) {
            if (_this.props.inputRef)
                _this.props.inputRef(element);
            _this.inputElement = element;
        };
        _this.initCleaveInstance = function (cleave) {
            _this.setState({ cleaveInstance: cleave });
        };
        return _this;
    }
    Object.defineProperty(MaskedTextField.prototype, "displayValue", {
        get: function () {
            if (this.props.formatFunction) {
                return this.props.formatFunction(this.props.value || '');
            }
            return this.props.value || '';
        },
        enumerable: false,
        configurable: true
    });
    MaskedTextField.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var _f = this.props, disabled = _f.disabled, errorText = _f.errorText, warningText = _f.warningText, helperText = _f.helperText, label = _f.label, id = _f.id, readOnly = _f.readOnly, maxLength = _f.maxLength, hideCharacterLimit = _f.hideCharacterLimit, testId = _f.testId, disabledTruncation = _f.disabledTruncation, multiline = _f.multiline, inputClasses = _f.inputClasses, onClear = _f.onClear, filterFunction = _f.filterFunction, formatFunction = _f.formatFunction, unformatFunction = _f.unformatFunction, singleSelect = _f.singleSelect, shrinkLabel = _f.shrinkLabel, autoCompleteType = _f.autoCompleteType, formatOptions = _f.formatOptions, hideWarningEmptyHelperText = _f.hideWarningEmptyHelperText, clearEmbeddedIcon = _f.clearEmbeddedIcon, fillContainer = _f.fillContainer, partiallyFillContainer = _f.partiallyFillContainer, alphanumeric = _f.alphanumeric, hiddenLabel = _f.hiddenLabel, hideErrorText = _f.hideErrorText, otherProps = __rest(_f, ["disabled", "errorText", "warningText", "helperText", "label", "id", "readOnly", "maxLength", "hideCharacterLimit", "testId", "disabledTruncation", "multiline", "inputClasses", "onClear", "filterFunction", "formatFunction", "unformatFunction", "singleSelect", "shrinkLabel", "autoCompleteType", "formatOptions", "hideWarningEmptyHelperText", "clearEmbeddedIcon", "fillContainer", "partiallyFillContainer", "alphanumeric", "hiddenLabel", "hideErrorText"]);
        var unifiedHelperText = errorText || warningText || helperText || '';
        if (readOnly) {
            // passing label: undefined still renders a label element.  null will hide it
            return (React.createElement(ReadOnlyField, { multiLine: multiline, label: !hiddenLabel ? label : null, hideHelperText: hideWarningEmptyHelperText && unifiedHelperText === '', alphanumeric: alphanumeric }, otherProps.startAdornment || this.displayValue));
        }
        var helperTextType = 'normal';
        if (errorText) {
            helperTextType = 'error';
        }
        else if (warningText) {
            helperTextType = 'warning';
        }
        if (!unifiedHelperText) {
            if (!!maxLength && maxLength > 0 && !!hideCharacterLimit !== true) {
                unifiedHelperText = this.props.value.length + "/" + maxLength;
            }
        }
        var inputClassesTotal = {
            root: classNames(styles.inputRoot, (_a = {},
                _a[styles.multiline] = multiline,
                _a), inputClasses && inputClasses.root),
            focused: styles.inputFocused,
            input: classNames(styles.input, (_b = {},
                _b[styles.truncated] = !disabledTruncation && !multiline && true,
                _b[styles.singleSelect] = singleSelect,
                _b), inputClasses && inputClasses.input),
            error: helperTextType === 'warning' ? styles.warningUnderline : ''
        };
        var helperTextClasses = {
            root: classNames(styles.helperText, (_c = {},
                _c[styles.warning] = helperTextType === 'warning',
                _c))
        };
        var autoCompleteValue = this.props.autoCompleteType === AutoCompleteTypes.UserInfo ? 'off-no-complete' : 'off';
        var clearAdornment = !!this.props.onClear &&
            !!this.displayValue &&
            !disabled &&
            !multiline &&
            !readOnly && (React.createElement(InputAdornment, { position: 'end', classes: {
                root: classNames(styles.clearAdornment, (_d = {},
                    _d[styles.clearEmbeddedIcon] = !!clearEmbeddedIcon,
                    _d))
            } },
            React.createElement(Button, { onMouseDown: this.onClear, size: 'small', classes: { root: styles.clearButton }, tabIndex: -1, "data-test-id": "textField_clear_" + this.props.testId },
                React.createElement(Icon, { classes: { root: styles.iconRoot } }, "cancel"))));
        var labelClasses = {
            root: styles.inputLabel
        };
        var inputLabel = !!label && (React.createElement(InputLabel, { htmlFor: id, shrink: true, classes: labelClasses },
            label || '',
            this.props.required && React.createElement("span", { className: styles.requiredLabel }, " *")));
        var formControlClasses = classNames(styles.formControl, (_e = {},
            _e[styles.fillContainer] = fillContainer,
            _e[styles.partiallyFillContainer] = partiallyFillContainer,
            _e[styles.alignRight] = this.props.align === AlignType.Right,
            _e[styles.errorState] = helperTextType === 'error',
            _e));
        return (React.createElement(FormControl, { disabled: disabled, fullWidth: true, error: helperTextType === 'error', classes: { root: formControlClasses }, "data-test-id": "textFieldContainer_" + this.props.testId, hiddenLabel: hiddenLabel },
            inputLabel,
            React.createElement(Input, __assign({}, otherProps, { endAdornment: clearAdornment, id: id, value: this.displayValue, autoComplete: autoCompleteValue, disabled: disabled, inputComponent: this.inputComponent, inputProps: {
                    maxLength: maxLength,
                    readOnly: readOnly,
                    'data-lpignore': 'true',
                    'data-test-id': "textField_" + this.props.testId
                }, inputRef: this.bindElement, multiline: multiline, rowsMax: this.props.rowsMax ? this.props.rowsMax : multiline ? '4' : undefined, classes: inputClassesTotal, error: !!errorText, onKeyDown: this.props.onKeyDown, onChange: this.onChange })),
            !hideErrorText && (!hideWarningEmptyHelperText || unifiedHelperText) && (React.createElement(FormHelperText, { classes: helperTextClasses }, unifiedHelperText || ' '))));
    };
    MaskedTextField.muiName = 'FormControl';
    return MaskedTextField;
}(React.Component));
export { MaskedTextField };
